// Document title per route, rendered most-specific-first and ending in EDDY,
// e.g. "Pods · Sandbox · Admin · EDDY", "Memory · EDDY". Home is just "EDDY".
//
// Built by mapping each known path segment to a label and joining the deepest
// section first. Unknown segments (record ids, slugs, action words like
// "new"/"edit") are dropped so a detail page reads as its parent section.
// ponytail: flat per-segment dict, deepen only if a child needs a richer label.
const DELIM = ' · ';

const SEGMENTS: Record<string, string> = {
  memory: 'Memory',
  work: 'Projects',
  files: 'Files',
  agents: 'Agents',
  crons: 'Schedule',
  skills: 'Skills',
  tools: 'Tools',
  integrations: 'Integrations',
  audit: 'Audit log',
  policy: 'Policy',
  security: 'Security',
  profile: 'Profile',
  diagnostics: 'Diagnostics',
  // FRONT-2376 review round 2 (item 8): plain "Settings" reads ambiguous now
  // that "System Settings" is a real, separate destination with its own tab
  // title below.
  settings: 'User Settings',
  'system-settings': 'System Settings',
  'org-settings': 'Org Settings',
  status: 'Status',
  notifications: 'Notifications',
  admin: 'Admin',
  sandbox: 'Sandbox',
  pods: 'Pods',
  apps: 'Apps',
  'custom-agents': 'Custom Agent',
};

export function pageTitle(pathname: string): string {
  const labels = pathname
    .split('/')
    .filter(Boolean)
    .map((seg) => SEGMENTS[seg])
    .filter((l): l is string => Boolean(l));
  if (labels.length === 0) return 'EDDY'; // home / inbox / unmapped
  return [...labels].reverse().concat('EDDY').join(DELIM);
}
